<script>
	import { mapActions, mapGetters } from 'vuex';
	import CertificationUploader from '@components/certifications/CertificationUploader.vue';
	import CertificationVersionHistory from '@components/certifications/CertificationVersionHistory.vue';

	export default {
		name: 'CertificationActionMenu',
		components: { CertificationVersionHistory, CertificationUploader },
		props: {
			certification: {
				type: Object,
				required: true
			}
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				loggedInEmployeeIsAdminOrManager: 'loggedInEmployeeIsAdminOrManager',
				certificationIsDeleted: 'certifications/isDeleted',
				deletingId: 'certificationActions/deletingId',
				remindingId: 'certificationActions/remindingId',
				downloadingId: 'certificationActions/downloadingId',
				certificationsExpiringSoon: 'certifications/expiringSoon',
				certificationsExpired: 'certifications/expired',
			}),
			isDeleting() {
				return this.deletingId === this.certification.id;
			},
			isDownloading() {
				return this.downloadingId === this.certification.id;
			},
			isExpiringSoonOrExpired() {
				return [...this.certificationsExpiringSoon, ...this.certificationsExpired].some(c => c.id === this.certification.id);
			},
			canDelete() {
				const isUnderling = this.loggedInEmployee.underlings != null && this.loggedInEmployee.underlings.includes(this.certification.employeeId);
				return this.loggedInEmployee.isAdmin || isUnderling;
			}
		},
		methods: {
			...mapActions({
				handleDownload: 'certificationActions/handleDownload',
				handleDelete: 'certificationActions/handleDelete',
				handleReminder: 'certificationActions/handleReminder',
				handleVersion: 'certificationActions/handleVersion'
			})
		}
	};
</script>

<template>
	<v-list>
		<v-list-tile v-if="loggedInEmployeeIsAdminOrManager && isExpiringSoonOrExpired" @click="handleReminder(certification)">
			<v-icon>mdi-send-clock</v-icon>
			<v-list-tile-title class="ml-2">Send Reminder to Employee</v-list-tile-title>
		</v-list-tile>
		<v-list-tile @click="handleVersion(certification)">
			<v-icon>mdi-history</v-icon>
			<v-list-tile-title class="ml-2">Version History</v-list-tile-title>
		</v-list-tile>
		<v-list-tile v-if="!certificationIsDeleted(certification.id) && canDelete" @click="handleDelete(certification)">
			<v-icon>mdi-delete</v-icon>
			<v-list-tile-title class="ml-2">Delete</v-list-tile-title>
		</v-list-tile>
	</v-list>
</template>

<style scoped></style>
